export const buildHref = (cf) => {
    var first = true;
    var href_param = "";
    cf.map((item)=>{
      var href_slugs = "";
      var added=false;
      item.values.map((value)=>{
        if(value.selected){
          href_slugs += (added?"-":"")+value.slug;
          added = true;
        }
      });
      if(href_slugs){
        href_param += (first?"?":"&")+item.name+"="+href_slugs;
        first=false;
      }
    });
    return href_param;
  }

  